import { ModuleWithProviders, NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicComponentComponent } from './dynamic-component.component';
import { DefaultDynamicComponentRegistryService, DynamicComponentRegistryService } from './dynamic-component-registry.service';
import { DynamicComponentRComponent } from './dynamic-component-r.component';

const ALL: Array<Type<void>> = [DynamicComponentComponent, DynamicComponentRComponent];

@NgModule({
  imports: [CommonModule],
  declarations: [...ALL],
  exports: [...ALL],
  providers: []
})
export class DynamicComponentModule {
  static forRoot(): ModuleWithProviders<DynamicComponentModule> {
    return {
      ngModule: DynamicComponentModule,
      providers: [{ provide: DynamicComponentRegistryService, useClass: DefaultDynamicComponentRegistryService }]
    };
  }
}
